export default __webpack_public_path__ + "static/media/MeditationBackground.6bd294be.png";